<div class="w-100 d-flex" [class.flex-row-reverse]="isRTL">

    <div class="position-absolute w-100 d-flex zx-z-index-2" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeLoginDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- video -->
    <div *ngIf="!isIphone()" class="zx-login-video-container position-relative overflow-hidden">
        <img src="../../../assets/images/eazix-logo-white.svg" alt="Eazix Logo"
            class="zx-logo-white svg position-absolute zx-z-index-2" [class.zx-logo-white-rtl]="isRTL">
        <video alt="Plotter Video" class="object-fit-contain zx-z-index-1" muted autoplay loop>
            <source src="../../../assets/videos/login-video.mp4" type="video/mp4">
        </video>
        <div class="position-absolute w-100 h-100">
            <img src="/assets/images/login-video-first-frame.jpg" class="w-100 h-100 object-fit-contain"
                alt="Plotter Image">
        </div>
    </div>

    <!-- login signup: phone (SMS code) first, the other methods below -->
    <div *ngIf="loginStage === 0"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 gap-2 overflow-auto">
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ (isPhoneSharedError ? "log-in-dialog-phone-shared-title" : "log-in-dialog-prelogin-title") | translate }}
        </h4>
        <p class="m-0 px-2 text-center" [class.text-white]="isDarkMode">
            {{ (isPhoneSharedError ? phoneLoginError : "log-in-dialog-prelogin-explanation") | translate }}
        </p>
        <span *ngIf="!isPhoneSharedError" class="spacer"></span>

        <div *ngIf="isPhoneSharedError" class="w-100 pt-2">
            <ng-container *ngTemplateOutlet="altLoginButtons"></ng-container>
        </div>

        <form *ngIf="!isPhoneSharedError" class="w-100 d-flex flex-column align-items-center gap-1"
            (ngSubmit)="onSendLoginCode()">
            <mat-form-field class="w-100 zx-login-phone-field" [class.zx-ltr-container]="!isRTL">
                <mat-label>{{ "log-in-dialog-phone-label" | translate }}</mat-label>
                <mat-icon matIconPrefix style="color: var(--zx-green);">smartphone</mat-icon>
                <input #phoneInput matInput name="phone" type="tel" inputmode="tel" autocomplete="tel-national"
                    dir="ltr" placeholder="050-1234567" [value]="phone" (input)="onPhoneInput(phoneInput)">
            </mat-form-field>
            <span *ngIf="phoneLoginError" class="w-100 text-center text-red zx-text-small">
                {{ phoneLoginError | translate }}
            </span>
            <button mat-raised-button color="primary" type="submit"
                class="text-white rounded-pill zx-btn-single zx-login-phone-btn"
                [disabled]="isLoading || !isPhoneValid || isPhoneLockedOut">
                <span *ngIf="!isSendingCode">{{ "log-in-dialog-phone-send-code" | translate }}</span>
                <mat-spinner *ngIf="isSendingCode" class="zx-small-icon-size m-auto"></mat-spinner>
            </button>
            <span *ngIf="isPhoneLockedOut" class="w-100 text-center text-red zx-text-small">
                {{ "otp-error.OTP_TOO_MANY_ATTEMPTS-wait" | translate: { seconds: resendCountdown } }}
            </span>
        </form>

        <div *ngIf="!isPhoneSharedError" class="w-100 d-flex align-items-center gap-2 pt-3 pb-3">
            <span class="zx-login-divider-line flex-grow-1" [class.zx-login-divider-line-dark]="isDarkMode"></span>
            <span class="zx-login-divider-text zx-text-small flex-shrink-0 text-center" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-or-continue-with" | translate }}
            </span>
            <span class="zx-login-divider-line flex-grow-1" [class.zx-login-divider-line-dark]="isDarkMode"></span>
        </div>

        <ng-container *ngIf="!isPhoneSharedError">
            <ng-container *ngTemplateOutlet="altLoginButtons"></ng-container>
        </ng-container>

        <ng-template #altLoginButtons>
        <div class="w-100 d-flex gap-2">
            <button type="button" [disabled]="isLoading" mat-stroked-button
                class="mat-stroked-button zx-login-alt-btn flex-grow-1" [class.mat-stroked-button-dark-mode]="isDarkMode"
                [attr.aria-label]="'log-in-dialog-prelogin-with-google' | translate" (click)="signInWithGoogle()">
                <div [class.opacity-50]="isLoadingGG" class="d-flex align-items-center justify-content-center gap-2">
                    <img class="zx-icon-log-in-alt" src="../../../assets/images/google-icon.svg" alt="">
                    <span class="zx-login-alt-label zx-text-medium">Google</span>
                </div>
                <div *ngIf="isLoadingGG" class="w-100 h-100 d-flex position-absolute top-0 start-0">
                    <mat-spinner class="zx-small-icon-size m-auto"></mat-spinner>
                </div>
            </button>
            <button type="button" [disabled]="isLoading" mat-stroked-button
                class="mat-stroked-button zx-login-alt-btn flex-grow-1" [class.mat-stroked-button-dark-mode]="isDarkMode"
                [attr.aria-label]="'log-in-dialog-prelogin-with-fb' | translate" (click)="signInWithFB()">
                <div [class.opacity-50]="isLoadingFB" class="d-flex align-items-center justify-content-center gap-2">
                    <img class="zx-icon-log-in-alt" src="../../../assets/images/fb-icon.svg" alt="">
                    <span class="zx-login-alt-label zx-text-medium">Facebook</span>
                </div>
                <div *ngIf="isLoadingFB" class="w-100 h-100 d-flex position-absolute top-0 start-0">
                    <mat-spinner class="zx-small-icon-size m-auto"></mat-spinner>
                </div>
            </button>
            <button type="button" [disabled]="isLoading" mat-stroked-button
                class="mat-stroked-button zx-login-alt-btn flex-grow-1" [class.mat-stroked-button-dark-mode]="isDarkMode"
                [attr.aria-label]="'log-in-dialog-prelogin-with-mail' | translate" (click)="toLoginStage(1)">
                <div [class.opacity-50]="isLoadingMail" class="d-flex align-items-center justify-content-center gap-2">
                    <img class="zx-icon-log-in-alt" src="../../../assets/images/mail-icon.svg" alt="">
                    <span class="zx-login-alt-label zx-text-medium">{{ "log-in-dialog-alt-mail" | translate }}</span>
                </div>
            </button>
        </div>
        </ng-template>

        <span class="spacer"></span>
        <button *ngIf="isPhoneSharedError" mat-raised-button color="primary" type="button"
            class="text-white rounded-pill zx-btn-single" style="margin-bottom: 15px;" (click)="onChangeSharedPhone()">
            {{ "log-in-dialog-phone-change" | translate }}
        </button>
        <p class="zx-p-container mb-0 text-center" [class.zx-ltr]="!isRTL">
            <span class="zx-text-medium" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-prelogin-t-and-c-1" | translate }}
            </span>
            <span *ngIf="selectedLanguage !== 'he'" class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" [class.text-white]="isDarkMode" (click)="goToTandC()">
                {{ "log-in-dialog-prelogin-t-and-c-tandc" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-prelogin-t-and-c-2" | translate }}
            </span>
            <span *ngIf="isRTL" class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" [class.text-white]="isDarkMode" (click)="goToPP()">
                {{ "log-in-dialog-prelogin-t-and-c-pp" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-prelogin-t-and-c-3" | translate }}
            </span>
        </p>
    </div>

    <!-- enter mail -->
    <div *ngIf="loginStage === 1"
        class="zx-login-content-container position-relative d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <button type="button" mat-icon-button class="zx-login-back-btn" [class.text-white]="isDarkMode"
            [disabled]="isLoading" [attr.aria-label]="'log-in-dialog-back' | translate" (click)="toLoginStage(0)">
            <mat-icon>{{ isRTL ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
        </button>
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-withmail-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-text-medium w-100" [class.text-white]="isDarkMode"
            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
            {{ "log-in-dialog-withmail-explanation" | translate }}
        </p>
        <div class="flex-grow-1 d-flex flex-column w-100" [class.zx-ltr-container]="!isRTL">
            <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
            <form class="d-flex flex-column flex-grow-1" (ngSubmit)="onEnterMail(enterMailForm)" #enterMailForm="ngForm"
                *ngIf="!isLoading">
                <span class="spacer"></span>
                <mat-form-field class="px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="email" ngModel type="email" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        [placeholder]="'log-in-dialog-withmail-email' | translate" #emailInput="ngModel" required email>
                    <mat-error *ngIf="emailInput.invalid" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        {{ "log-in-dialog-mailexist-mail-not-valid" | translate }}
                    </mat-error>
                </mat-form-field>
                <span class="spacer login-spacer-above-continue"
                    [class.login-spacer-active]="showSpacerAboveContinue"></span>
                <div class="d-flex justify-content-center w-100 pt-3">
                    <button mat-raised-button color="primary" type="submit"
                        [disabled]="isLoading || enterMailForm.invalid || !emailInput.value || emailInput.value === ''"
                        class="text-white rounded-pill zx-btn-single">
                        {{ "choose-system.continue" | translate }}
                    </button>
                </div>
                <span class="spacer login-spacer-below-continue"
                    [class.login-spacer-active]="showSpacerBelowContinue"></span>
            </form>
        </div>
    </div>

    <!-- mail exist (ENTER YOUR PASSWORD) -->
    <div *ngIf="loginStage === 2"
        class="zx-login-content-container position-relative d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <button type="button" mat-icon-button class="zx-login-back-btn" [class.text-white]="isDarkMode"
            [disabled]="isLoading" [attr.aria-label]="'log-in-dialog-back' | translate" (click)="toLoginStage(1)">
            <mat-icon>{{ isRTL ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
        </button>

        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-mailexist-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-p-container" [class.text-white]="isDarkMode"
            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-1" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="fw-bold zx-text-medium">
                {{email}}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-2" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(1)">
                {{ "log-in-dialog-mailexist-back-to-mail" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-3" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(4)">
                {{ "log-in-dialog-mailexist-reset-password" | translate }}
            </span>
            <span class="zx-text-medium">.</span>
        </p>
        <div class="d-flex flex-column w-100 flex-grow-1" [class.zx-ltr-container]="!isRTL">
            <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
            <form class="d-flex flex-column flex-grow-1" (ngSubmit)="onLoginMail(enterPasswordForm)"
                #enterPasswordForm="ngForm" *ngIf="!isLoading">
                <span class="spacer"></span>
                <mat-form-field class="px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'" type="{{ loginHidePassword ? 'password' : 'text' }}"
                        matInput name="password" ngModel type="password"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #passwordInput="ngModel" required
                        password>
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="toggleLoginPasswordVisibility()">
                        <mat-icon>{{ loginHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="passwordInput.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                    </mat-error>
                </mat-form-field>
                <span class="spacer login-spacer-above-continue"
                    [class.login-spacer-active]="showSpacerAboveContinue"></span>
                <div class="d-flex justify-content-center w-100 pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading"
                        [disabled]="isLoading || enterPasswordForm.invalid || !passwordInput.value || passwordInput.value === ''"
                        class="text-white rounded-pill zx-btn-single">
                        {{ "choose-system.continue" | translate }}
                    </button>
                </div>
                <span class="spacer login-spacer-below-continue"
                    [class.login-spacer-active]="showSpacerBelowContinue"></span>
            </form>
        </div>
    </div>

    <!-- mail NOT exist (CREATE A PASSWORD) -->
    <div *ngIf="loginStage === 3"
        class="zx-login-content-container position-relative d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <button type="button" mat-icon-button class="zx-login-back-btn" [class.text-white]="isDarkMode"
            [disabled]="isLoading" [attr.aria-label]="'log-in-dialog-back' | translate" (click)="toLoginStage(1)">
            <mat-icon>{{ isRTL ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
        </button>
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-mailnotexist-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-p-container" [class.text-white]="isDarkMode"
            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailnotexist-explanation-1" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="fw-bold zx-text-medium">
                {{email}}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-medium">
                {{ "log-in-dialog-mailexist-explanation-2" | translate }}
            </span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(1)">
                {{ "log-in-dialog-mailexist-back-to-mail" | translate }}
            </span>
            <span class="zx-text-medium">.</span>
        </p>
        <div class="d-flex flex-column w-100 flex-grow-1" [class.zx-ltr-container]="!isRTL">
            <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
            <form class="d-flex flex-column flex-grow-1" (ngSubmit)="onSignupMail(enterPasswordForm)"
                #enterPasswordForm="ngForm" *ngIf="!isLoading">
                <div class="d-flex flex-column justify-content-end flex-grow-1 zx-text-small">
                    <span class="px-2 pb-3">
                        {{ "log-in-dialog-mailexist-password-instructions" | translate }}
                    </span>
                </div>
                <mat-form-field class="px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="password" ngModel type="password" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ signupHidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #passwordInput="ngModel" required
                        minlength="10" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="toggleSignupPasswordVisibility()">
                        <mat-icon>{{ signupHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="passwordInput.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="passwordInput.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                        </span>
                        <span *ngIf="passwordInput.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-minlength" | translate }}
                        </span>
                        <span *ngIf="passwordInput.hasError('pattern')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-pattern" | translate }}
                        </span>
                    </mat-error>
                </mat-form-field>
                <span class="spacer"></span>
                <div class="d-flex justify-content-center w-100 w-lg-none pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading" [disabled]="isLoading || enterPasswordForm.invalid || !passwordInput.value || passwordInput.value === '' ||
                        passwordInput.hasError('required') ||
                        passwordInput.hasError('minlength') ||
                        passwordInput.hasError('pattern')" class="text-white rounded-pill zx-btn-single">
                        {{ "choose-system.continue" | translate }}
                    </button>
                </div>
            </form>

        </div>
    </div>

    <!-- RESET PASSWORD -->
    <div *ngIf="loginStage === 4"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">

        <!-- LOADER -->
        <div *ngIf="isLoading" class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
            <mat-spinner class="zx-medium-icon-size"></mat-spinner>
        </div>
        <!-- // LOADER -->

        <!-- title -->
        <div *ngIf="!isLoading" class="d-flex flex-column justify-content-center w-100 gap-1">
            <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
                {{ "log-in-dialog-reset-password.title" | translate }}
            </h4>
            <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
                <b *ngIf="email.length > 18 && isRTL">
                    ...
                </b>
                <b>
                    {{ email | slice:0:18 }}
                </b>
                <b *ngIf="email.length > 18 && !isRTL">
                    ...
                </b>
            </h4>
        </div>
        <!-- // title -->

        <!-- BEFORE checking pass reset code -->
        <div *ngIf="isPassResetCodeSentToCheck && !isPassResetCodeCorrect && !isPassResetCodeAproved && !isLoading"
            class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">

            <span [class.text-white]="isDarkMode">
                <span>
                    {{ "log-in-dialog-reset-password.explain-1" | translate }}
                </span>
                <span>
                    <b *ngIf="email.length > 18 && isRTL">
                        ...
                    </b>
                    <b>
                        {{ email | slice:0:18 }}
                    </b>
                    <b *ngIf="email.length > 18 && !isRTL">
                        ...
                    </b>
                </span>
                <span>
                    {{ "log-in-dialog-reset-password.explain-2" | translate }}
                </span>
            </span>

            <span class="spacer"></span>

            <form class="w-100 d-flex flex-column flex-grow-1" #form="ngForm"
                (ngSubmit)="submitPassResetCode(passResetCode)">
                <mat-form-field class="px-4 py-2 w-100" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="passResetCode" [(ngModel)]="passResetCode" type="password"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ passResetCodeHidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-reset-password.code-in-email' | translate"
                        #passResetCodeInput="ngModel" required maxlength="10" minlength="10" class="w-100">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="togglePassResetCodeVisibility()">
                        <mat-icon>{{ passResetCodeHidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="passResetCodeInput.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="passResetCodeInput.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-reset-password.not-valid" | translate }}
                        </span>
                        <span *ngIf="passResetCodeInput.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-reset-password.not-valid-minlength" | translate }}
                        </span>
                    </mat-error>
                </mat-form-field>

                <span class="spacer"></span>

                <div class="d-flex justify-content-center w-100 w-lg-none pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading" [disabled]="isLoading || !form.valid"
                        class="text-white rounded-pill zx-btn-single">
                        {{ "error-content-ok-btn" | translate }}
                    </button>
                </div>
            </form>
        </div>
        <!-- // BEFORE checking pass reset code -->

        <!-- AFTER checking pass reset code -->
        <div *ngIf="!isPassResetCodeSentToCheck && isPassResetCodeCorrect && !isPassResetCodeAproved && !isLoading"
            class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
            <span class="spacer"></span>

            <form class="w-100 d-flex flex-column flex-grow-1" #form="ngForm"
                (ngSubmit)="resetPassword(newPass1, newPass2)">

                <span>{{ 'log-in-dialog-withmail-password' | translate }}</span>

                <!-- Password Field 1 -->
                <mat-form-field class="w-100 px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <input matInput name="newPass1" [(ngModel)]="newPass1" type="password"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ passResetNewCode1HidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #newPass1Input="ngModel" required
                        minlength="10" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="togglePassResetNewCode1Visibility()">
                        <mat-icon>{{ passResetNewCode1HidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="newPass1Input.invalid"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="newPass1Input.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                        </span>
                        <span *ngIf="newPass1Input.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-minlength" | translate }}
                        </span>
                        <span *ngIf="newPass1Input.hasError('pattern')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-pattern" | translate }}
                        </span>
                    </mat-error>
                </mat-form-field>

                <span class="spacer"></span>

                <span>{{ 'log-in-dialog-confirm-password' | translate }}</span>

                <!-- Password Field 2 -->
                <mat-form-field class="w-100 px-4 py-2" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">

                    <input matInput name="newPass2" [(ngModel)]="newPass2" type="password"
                        [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'"
                        type="{{ passResetNewCode2HidePassword ? 'password' : 'text' }}"
                        [placeholder]="'log-in-dialog-withmail-password' | translate" #newPass2Input="ngModel" required
                        minlength="10" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$">
                    <button type="button" [ngClass]="isRTL ? 'zx-eye-icon-rtl' : 'zx-eye-icon'" mat-icon-button
                        (click)="togglePassResetNewCode2Visibility()">
                        <mat-icon>{{ passResetNewCode2HidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        <span *ngIf="newPass2Input.hasError('required')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid" | translate }}
                        </span>
                        <span *ngIf="newPass2Input.hasError('minlength')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-minlength" | translate }}
                        </span>
                        <span *ngIf="newPass2Input.hasError('pattern')" class="d-inline-block">
                            {{ "log-in-dialog-mailexist-password-not-valid-pattern" | translate }}
                        </span>
                    </mat-error>

                </mat-form-field>

                <span class="spacer"></span>

                <div *ngIf="newPass1Input.valid && newPass2Input.valid && newPass1 !== newPass2"
                    [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'" class="zx-text-tiny text-red px-2">
                    {{ "log-in-dialog-mailexist-password-not-match" | translate }}
                </div>

                <div class="d-flex justify-content-center w-100 w-lg-none pt-3">
                    <button mat-raised-button color="primary" type="submit" *ngIf="!isLoading"
                        [disabled]="isLoading || !form.valid || newPass1 !== newPass2" class="text-white rounded-pill zx-btn-single">
                        {{ "error-content-ok-btn" | translate }}
                    </button>
                </div>
            </form>

        </div>
        <!-- // AFTER checking pass reset code -->

        <!-- sucsessfully reseted -->
        <div *ngIf="isPassResetCodeAproved && !isLoading"
            class="w-100 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
            <h2>
                {{ "log-in-dialog-reset-password.success" | translate }}
            </h2>
        </div>
        <!-- // sucsessfully reseted -->

    </div>

    <!-- PHONE - ENTER SMS CODE -->
    <div *ngIf="loginStage === 5"
        class="zx-login-content-container position-relative d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <button type="button" mat-icon-button class="zx-login-back-btn" [class.text-white]="isDarkMode"
            [disabled]="isLoading" [attr.aria-label]="'log-in-dialog-back' | translate" (click)="toLoginStage(0)">
            <mat-icon>{{ isRTL ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
        </button>
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-code-title" | translate }}
        </h4>
        <p class="m-0 px-2 text-center zx-p-container" [class.text-white]="isDarkMode">
            <span class="zx-text-medium">{{ "log-in-dialog-code-sent-to" | translate }}</span>
            <span class="zx-text-medium zx-text-transparent">-</span>
            <b class="zx-text-medium d-inline-block" dir="ltr">{{ formattedPhone }}</b>
        </p>
        <p class="m-0 px-2 text-center zx-text-medium opacity-50" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-code-sent-via" | translate }}
        </p>
        <p class="m-0 px-2 text-center" [class.text-white]="isDarkMode">
            <span class="zx-text-link zx-text-medium" (click)="toLoginStage(0)">
                {{ "log-in-dialog-code-change-phone" | translate }}
            </span>
        </p>
        <span class="spacer"></span>

        <app-otp-code-input class="w-100 zx-login-code" [disabled]="isLoading || isCodeLocked" [hasError]="!!codeError"
            [isDarkMode]="isDarkMode" (codeComplete)="onVerifyLoginCode($event)"></app-otp-code-input>

        <div class="zx-otp-feedback d-flex flex-column align-items-center justify-content-center text-center">
            <mat-spinner *ngIf="isLoading" class="zx-small-icon-size"></mat-spinner>
            <span *ngIf="!isLoading && codeError" class="text-red zx-text-small">
                {{ (isCodeLocked && resendCountdown > 0 ? "otp-error.OTP_TOO_MANY_ATTEMPTS-wait" : codeError)
                | translate: { seconds: resendCountdown } }}
                <span *ngIf="codeAttemptsLeft">
                    ({{ "otp-error.attempts-left" | translate }} {{ codeAttemptsLeft }})
                </span>
            </span>
            <button *ngIf="!isLoading && isCodeExpired" mat-raised-button color="primary" type="button"
                class="text-white rounded-pill mt-2" [disabled]="resendCountdown > 0" (click)="onResendLoginCode()">
                {{ "log-in-dialog-code-send-new" | translate }}
            </button>
        </div>

        <span class="spacer"></span>
        <button *ngIf="!isCodeExpired" [style.visibility]="isCodeLocked && resendCountdown > 0 ? 'hidden' : null" mat-button type="button" class="rounded-pill" [class.text-white]="isDarkMode"
            [disabled]="isLoading || resendCountdown > 0" (click)="onResendLoginCode()">
            <span *ngIf="resendCountdown > 0">
                {{ "log-in-dialog-code-resend-in" | translate }} <span dir="ltr">{{ resendCountdownLabel }}</span>
            </span>
            <span *ngIf="resendCountdown === 0">{{ "log-in-dialog-code-resend" | translate }}</span>
        </button>
    </div>

    <!-- PHONE - NEW ACCOUNT DETAILS -->
    <div *ngIf="loginStage === 6"
        class="zx-login-content-container position-relative d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 gap-2 overflow-auto">
        <button type="button" mat-icon-button class="zx-login-back-btn" [class.text-white]="isDarkMode"
            [disabled]="isLoading" [attr.aria-label]="'log-in-dialog-back' | translate" (click)="backFromRegistration()">
            <mat-icon>{{ isRTL ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
        </button>
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-register-title" | translate }}
        </h4>
        <p class="m-0 px-2 text-center zx-text-medium" [class.text-white]="isDarkMode">
            <span>{{ "log-in-dialog-register-explanation" | translate }}</span>
            <span class="zx-text-transparent">-</span>
            <b class="d-inline-block" dir="ltr">{{ formattedPhone }}</b>
        </p>
        <div *ngIf="isLoading" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
            <mat-spinner class="zx-medium-icon-size"></mat-spinner>
        </div>
        <form *ngIf="!isLoading" class="w-100 d-flex flex-column flex-grow-1" #registerForm="ngForm"
            (ngSubmit)="onRegisterWithPhone(registerForm)" [class.zx-ltr-container]="!isRTL">
            <div class="d-flex gap-2">
                <mat-form-field class="flex-grow-1 zx-min-w-0" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <mat-label>{{ "log-in-dialog-register-first-name" | translate }}</mat-label>
                    <input matInput name="firstName" ngModel autocomplete="given-name" required maxlength="50">
                </mat-form-field>
                <mat-form-field class="flex-grow-1 zx-min-w-0" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                    <mat-label>{{ "log-in-dialog-register-last-name" | translate }}</mat-label>
                    <input matInput name="lastName" ngModel autocomplete="family-name" maxlength="50">
                </mat-form-field>
            </div>
            <mat-form-field class="w-100" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                <mat-label>{{ "log-in-dialog-withmail-email" | translate }}</mat-label>
                <input matInput name="registerEmail" ngModel type="email" dir="ltr" autocomplete="email" email
                    [required]="phoneSignupRequiresEmail" #registerEmailInput="ngModel">
                <mat-hint [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ "log-in-dialog-register-email-hint" | translate }}
                </mat-hint>
                <mat-error *ngIf="registerEmailInput.invalid" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ "log-in-dialog-mailexist-mail-not-valid" | translate }}
                </mat-error>
            </mat-form-field>
            <span *ngIf="registerError" class="w-100 text-center text-red zx-text-small pt-2">
                {{ registerError | translate }}
            </span>
            <span class="spacer"></span>
            <div class="d-flex justify-content-center w-100 pt-3">
                <button mat-raised-button color="primary" type="submit" [disabled]="isLoading || registerForm.invalid"
                    class="text-white rounded-pill zx-btn-single">
                    {{ "log-in-dialog-register-submit" | translate }}
                </button>
            </div>
        </form>
    </div>

    <!-- PHONE - SEVERAL ACCOUNTS SHARE THIS NUMBER -->
    <div *ngIf="loginStage === 7"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-accounts-title" | translate }}
        </h4>
        <p class="m-0 px-2 text-center zx-text-medium" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-accounts-explanation" | translate }}
        </p>
        <div class="w-100 d-flex flex-column gap-2 overflow-auto py-1">
            <button *ngFor="let account of phoneAccounts" type="button" mat-stroked-button
                class="mat-stroked-button w-100" [class.mat-stroked-button-dark-mode]="isDarkMode"
                [disabled]="isLoading" (click)="onSelectPhoneAccount(account)">
                <div class="w-100 d-flex align-items-center gap-3 py-1" [class.flex-row-reverse]="!isRTL">
                    <img *ngIf="account.provider === 'google'" class="zx-icon-log-in-alt"
                        src="../../../assets/images/google-icon.svg" alt="Google">
                    <img *ngIf="account.provider === 'facebook'" class="zx-icon-log-in-alt"
                        src="../../../assets/images/fb-icon.svg" alt="Facebook">
                    <img *ngIf="account.provider !== 'google' && account.provider !== 'facebook'"
                        class="zx-icon-log-in-alt" src="../../../assets/images/mail-icon.svg" alt="">
                    <div class="d-flex flex-column flex-grow-1" [ngClass]="isRTL ? 'text-end' : 'text-start'">
                        <span class="fw-bold zx-text-medium" dir="ltr">
                            {{ account.maskedEmail || ("log-in-dialog-accounts-no-email" | translate) }}
                        </span>
                        <span class="zx-text-small">
                            {{ "log-in-dialog-accounts-created" | translate }} {{ account.created | date:'dd/MM/yyyy' }}
                        </span>
                    </div>
                </div>
            </button>
        </div>
        <div *ngIf="isLoading" class="d-flex justify-content-center">
            <mat-spinner class="zx-small-icon-size"></mat-spinner>
        </div>
        <span class="spacer"></span>
        <span class="zx-text-link zx-text-medium" [class.text-white]="isDarkMode" (click)="toLoginStage(0)">
            {{ "log-in-dialog-mailexist-back-to-mail" | translate }}
        </span>
    </div>

    <!-- PHONE - SIGN-UP EMAIL ALREADY HAS AN ACCOUNT -->
    <div *ngIf="loginStage === 8"
        class="zx-login-content-container d-flex flex-grow-1 h-100 flex-column align-items-center px-3 py-4 px-md-4 py-md-5 gap-3">
        <h4 class="text-center fw-bold m-0" [class.text-white]="isDarkMode">
            {{ "log-in-dialog-email-exists-title" | translate }}
        </h4>
        <p class="m-0 px-2 text-center zx-text-medium" [class.text-white]="isDarkMode">
            <span>{{ "log-in-dialog-email-exists-explanation-1" | translate }}</span>
            <span class="zx-text-transparent">-</span>
            <b class="d-inline-block" dir="ltr">{{ email }}</b>
            <span>.</span>
            <span class="zx-text-transparent">-</span>
            <span *ngIf="provider !== 'phone' || hasPassword">
                {{ "log-in-dialog-email-exists-explanation-2" | translate }}
            </span>
            <span *ngIf="provider === 'phone' && !hasPassword">
                {{ "log-in-dialog-email-exists-phone-account" | translate }}
            </span>
        </p>
        <span class="spacer"></span>
        <button *ngIf="provider !== 'phone' || hasPassword" mat-raised-button color="primary" type="button"
            class="text-white rounded-pill zx-btn-single" [disabled]="isLoading" (click)="onLoginToExistingAccount()">
            <span *ngIf="provider === 'google'">{{ "log-in-dialog-prelogin-with-google" | translate }}</span>
            <span *ngIf="provider === 'facebook'">{{ "log-in-dialog-prelogin-with-fb" | translate }}</span>
            <span *ngIf="provider !== 'google' && provider !== 'facebook'">
                {{ "log-in-dialog-email-exists-with-password" | translate }}
            </span>
        </button>
        <span class="spacer"></span>
        <span class="zx-text-link zx-text-medium" [class.text-white]="isDarkMode" (click)="toLoginStage(6)">
            {{ "log-in-dialog-email-exists-other-email" | translate }}
        </span>
    </div>

</div>